import { h, Component, createRef } from 'preact';

import { connect } from 'react-redux';
import Masonry from 'react-masonry-component';
import Cropper from 'react-cropper';
import reduce from '../reducers';
import * as actions from '../actions';

import imageService from '../service/imageService';
import brandService from '../service/brandService';
import Spinner from './Spinner';

import constants, { MyMenusPath } from '../constants';

import 'cropperjs/dist/cropper.min.css';

import util, { toLogIn } from '../util';

export default @connect(reduce, actions)
class AsideLogos extends Component {
    constructor() {
        super();
        this.state = {
            images: [],
            isUploadLoading: false,
            isLoading: false,
            uploadErrMsg: '',

            isCropping: false,
            imageCropSrc: '',
            cropResult: null,
        };

        this.auth = () => {
            toLogIn();
        };

        this.goToBrandingPage = () => {
            window.open(MyMenusPath + '/brand', '_blank');
            this.props.goToSubview('root');
        };

        this.imagePath = (image) => {
            let url = !image.isOld ? `https://timber.mhmcdn.com/${image.path}` : window.location.origin + image.path;
            url = url.replace(/ /g,'%20');
            return url;
        }
    }

    componentDidMount() {
        if (this.props.isLogged) {
            this.setState({ isLoading: true });

            if (this.props.brand.logos) {
                this.setState({ images: this.props.brand.logos });
                this.setState({ isLoading: false });
            }
        }
    }

    uploadLogoClick(event) {
        try {
            // if (!this.props.hasPdfPermission) {
            //     event.preventDefault();
            // } else {
                /* if(this.state.images.length >= 8){
                    event.preventDefault();
                    window.InfoModal.show({
                        title: 'Limit Reached!',
                        body: 'Maximum eight logos can be uploaded.',
                        acceptLabel: 'Got it',
                    })
                    event.target.value = '';
                    return false;
                } */
            // }
        } catch (err) {
            console.log(err.stack);
        }
    }

    onChange(event) {
        const { files } = event.target;
        const formData = new FormData();

        if (!files.length) return;
        let fileTypeValid = false;
        const fileType = files[0].type.toLowerCase();
        if (fileType === 'image/jpeg' || fileType === 'image/png' || fileType === 'image/svg+xml' || fileType === 'image/gif') {
            fileTypeValid = true;
        }
        if (!fileTypeValid) {
            window.InfoModal.show({
                title: 'File type not supported!',
                body: 'Supported file types are svg, png, jpg/jpeg, and gif.',
                acceptLabel: 'Got it',
            });
            return;
        }
        let isSizeValid = true;
        const max = 10 * 1024 * 1024; // 10MB
        for (let idx = 0; idx < files.length; idx++) {
            if (files[idx].size > max) {
                isSizeValid = false;
            }
        }
        if (!isSizeValid) {
            window.ConfirmationModal.show({
                title: 'File exceeds limit',
                body: "This image can\'t be uploaded because it exceeds the 10MB file size limit.",
                acceptLabel: 'Ok',
                hideDecline: true,
                onAccept: () => {
                    window.ConfirmationModal.hide();
                },
            });
            return;
        }

        function cleanFileName(name) {
            return name.replaceAll('+', '');
        }

        Array.from(Array(files.length).keys())
            .map((x) => {
                formData.append('file', files[x], cleanFileName(files[x].name));
            });

        this.setState({
            isUploadLoading: true,
            isCropping: false,
            imageCropSrc: '',
        });

        brandService.uploadBrandLogo(this.props.brand.id, formData).then((response) => {
            this.setState({ isUploadLoading: false });
            this.setState({ images: [response.data, ...this.state.images] });
            this.props.brand.logos.push(response.data)
        }).catch((err) => {
            this.setState({ isUploadLoading: false });
            if (!err.response || err.response.data.message) {
                let errMsg = '';
                const isMaxUploadErr = !err.response || err.response.data.message.indexOf('Maximum upload') > -1;

                if (isMaxUploadErr) {
                    errMsg = "This image can\'t be uploaded because it exceeds the 10MB file size limit.";

                    window.ConfirmationModal.show({
                        title: 'File exceeds limit',
                        body: errMsg,
                        acceptLabel: 'Ok',
                        hideDecline: true,
                        onAccept: () => {
                            window.ConfirmationModal.hide();
                        },
                    });
                }
            }
        });
    }

    removeImage(image, event) {
        event.stopPropagation();

        window.ConfirmationModal.show({
            title: 'Are you sure?',
            body: 'This image will be removed from your gallery.',
            acceptLabel: 'Ok',
            declineLabel: 'Cancel',
            onAccept: () => {
                imageService.removeMemberImage(image.id).then((response) => {
                    this.setState({ images: this.state.images.filter((it) => it.id !== image.id) });
                });
            },
            onDecline: () => {
                window.ConfirmationModal.hide();
            },
        });
    }

    openCropper(image, event) {
        event.stopPropagation();

        this.setState({
            isCropping: true,
            imageCropSrc: `${constants.urlPrefix}/api/image/s3/${image.id}`,
        });
    }

    closeCropper() {
        this.setState({
            isCropping: false,
            imageCropSrc: '',
        });
    }

    cropImage() {
        if (typeof this.cropper.cropper.getCroppedCanvas() === 'undefined') {
            return;
        }

        this.setState({
            cropResult: this.cropper.cropper.getCroppedCanvas().toDataURL(),
        });

        this.cropper.cropper.getCroppedCanvas({
            maxWidth: 1024,
            maxHeight: 1024,
            imageSmoothingEnabled: 'false',
        }).toBlob((blob) => {
            if (blob) {
                const formData = new FormData();
                // Pass the image file name as the third parameter if necessary.
                formData.append('file', blob, `${util.UUID.get()}_cropped.png`);

                this.setState({ isUploadLoading: true });

                brandService.uploadBrandLogo(this.props.brand.id, formData).then((response) => {
                    this.setState({
                        isUploadLoading: false,
                        images: [response.data, ...this.state.images],
                        isCropping: false,
                        imageCropSrc: '',
                    });
                    this.props.brand.logos.push(response.data)
                }).catch((err) => {
                    this.setState({ isUploadLoading: false });
                });
            }
        });
    }

    render(props, state) {
        let uploadBox = null;

        if (!props.isLogged) {
            uploadBox = <div>
                <p>This step requires an account</p>
                <a class="btn tertiary" onClick={ this.auth }>Log In / Sign Up</a>
            </div>;
        } else if (state.isUploadLoading && !state.isCropping) {
            uploadBox = <Spinner />;
        } else {
            uploadBox = <div>
                <input type="file" name="image" onChange={ this.onChange.bind(this) } onClick={ this.uploadLogoClick.bind(this) } onDrop={ this.uploadLogoClick.bind(this) } accept="image/jpeg,image/gif,image/png" class="input-file" multiple />
                <div>
                    <p>Drag and drop files here or </p>
                    <a class="btn primary medium">
                        <span>Choose Images</span>
                    </a>
                </div>
            </div>;
        }

        const uploadErrorMessage = state.uploadErrMsg ? <div class="upload-err">{state.uploadErrMsg}</div> : null;

        const imageLoadingSpinner = state.isLoading ? <Spinner /> : null;

        let discoverLogoLbl = <div className={'myFontsLinkCont'}>Manage your logos with <a className={'myFontsLink lk'} href="javascript: void(0)" onClick={ this.goToBrandingPage }>My Brand</a></div>;

        const elements = state.images.map((image) => (
                <div class="component template frame" data-component="frame">
                    <div class="frame" data-component="frame" data-type="frame" style="display: table-row;" data-asset-id={image.assetId}>
                        <div class="img" data-original-bg-img={this.imagePath(image)} style={`width: 100%; height: 100%;`}>
                            <picture>
                                <img loading={'lazy'} style="width: 100%; height: 100%;" className="img" src={this.imagePath(image)} alt={image.altText} />
                            </picture>
                        </div>
                    </div>
                </div>
            ));

        const imageElements = (<Masonry updateOnEachImageLoad={true} className={'masonry-grid'}>
            {elements}
        </Masonry>);

        const cropperFooterElement = state.isUploadLoading ? <Spinner small={ true } />
            : <div class="footer">
                <a class="btn primary pull-right" onClick={() => this.cropImage()}>Crop</a>
                <a class="btn tertiary pull-right" onClick={() => this.closeCropper()}>Cancel</a>
            </div>;

        const cropperElement = state.isCropping
            ? <div class="upload-cropper">
                <div class="container">
                    <Cropper
                        ref={(cropper) => {
                            this.cropper = cropper;
                        }}
                        src={state.imageCropSrc}
                        style={{ height: 300, width: 'auto' }}
                        guides={true}
                        zoomable={false}
                        background={false}
                        viewMode={2}
                        checkCrossOrigin={false}
                    />
                </div>

                { cropperFooterElement }
            </div>
            : '';

        return (
            <div id="app-aside-uploads" class="aside-text aside-logos">
                { cropperElement }
                <div class="to-root">
                    <a onClick={ () => props.goToRoot() }>
                        All graphics
                    </a>
                    <span class="path">&gt;&nbsp; Logos</span>
                </div>

                {!props.isPhotoSwap && !props.isReplaceFrameMode &&
                <div class="dropbox">
                    { uploadBox }
                    { uploadErrorMessage }
                </div>}
                {!props.isReplaceFrameMode && discoverLogoLbl }

                <div class={"scroller" + (props.isReplaceFrameMode ? " replace-mode" : "")}>
                    { imageLoadingSpinner }
                    <div class="components images">
                        { imageElements }
                    </div>
                </div>
            </div>
        );
    }
}
